import AxiosUtil from '../utils/axiosUtil';

export const MyInfoService = (function () {
  let instance;
  // const BASE_URI = 'base service uri'

  function init() {
    return {
      myInfo: async function () {
        return await AxiosUtil.Async.get('/apis/my-info');
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
